import React, { useState, useEffect, useContext } from "react";
import recruiter_header_logo from "../../components/basicInfoForm/images/logo_recruiter_header.png";
import "./Header.css";
import profile from "../../components/basicInfoForm/images/avatar.png";
import ClickAwayListener from '@mui/material/ClickAwayListener';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import SupportAgentIcon from '@mui/icons-material/SupportAgent';
import LogoutIcon from '@mui/icons-material/Logout';
import AdminPanelSettingsIcon from '@mui/icons-material/AdminPanelSettings';
import SettingsIcon from '@mui/icons-material/Settings';
import { useLocation, useNavigate } from "react-router-dom";
import NotificationsIcon from '@mui/icons-material/Notifications';
import HomeContactUsModal from "../../pages/home/homeHeader/homeContactUsModal/homeContactUs";
import { UserTypeContext } from "../../AppRoute";
import getAllNotification from "../../apis/getAllNotification/getAllNotification";
import Badge from '@mui/material/Badge';
// Tooltip already imported elsewhere in this file
import MenuIcon from '@mui/icons-material/Menu';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import Tooltip from '@mui/material/Tooltip';
import SearchIcon from '@mui/icons-material/Search';
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import DashboardCustomizeIcon from '@mui/icons-material/DashboardCustomize';
import FolderSharedIcon from '@mui/icons-material/FolderShared';
// removed unused icons
import DescriptionIcon from '@mui/icons-material/Description';
import ContactMailIcon from '@mui/icons-material/ContactMail';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import updateNotification from "../../apis/updateNotification/updateNotification";
import userSessionLogs from "../../apis/userSessionLogs";
import customLogoutResponse from "../../apis/logout/customLogout";
import MuiAlert from "@mui/material/Alert";
import Snackbar from "@mui/material/Snackbar";
import allRoles from '../../apis/getAllRoles/getRoles';
import Collapse from "@mui/material/Collapse";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import Box from "@mui/material/Box";
import CssBaseline from "@mui/material/CssBaseline";
import MuiDrawer from "@mui/material/Drawer";
import ListItemButton from "@mui/material/ListItemButton";
import ExpandLess from '@mui/icons-material/ExpandLess';
import ExpandMore from '@mui/icons-material/ExpandMore';
import PersonPinCircleOutlined from '@mui/icons-material/PersonPinCircleOutlined';
import { styled } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';
import UploadResumeModal from "../UploadResumeModal/UploadResumeModal";
import DashboardIcon from '@mui/icons-material/Dashboard';
import SharePowerResume from "../SharePoweResumeModal/SharePowerResume";
import {
  ReportsIcon,
  AddPlusIcon,
  StarIcon,
  PendingInvitesIcon,
  PendingReferralIcon,
  PendingResumeValidationIcon,
  ShareIcon,
  ManageTeamIcon,
  ManageDivisionIcon,
  ManageClientIcon,
  ManagePOCIcon,
  ManageUserIcon,
  SwitchRoleIcon,
  PendingActionsIcon,
  RequisitionsIcon,
  DropdownArrowIcon
} from '../Icons/headericon';
import Backdrop from "@mui/material/Backdrop";
import CircularProgress from "@mui/material/CircularProgress";
import VetIcon from "../Icons/veticon";
// Add the drawer width and styled components with ClearedTalent theme
const drawerWidth = 320;

const openedMixin = (theme) => ({
  width: drawerWidth,
  transition: theme.transitions.create('width', {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.enteringScreen,
  }),
  overflowX: 'hidden',
  background: '#ffffff',
  zIndex: 1400,
});

const closedMixin = (theme) => ({
  transition: theme.transitions.create('width', {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  overflowX: 'hidden',
  width: `calc(${theme.spacing(7)} + 1px)`,
  background: '#ffffff',
  zIndex: 1400,
  [theme.breakpoints.up('sm')]: {
    width: `calc(${theme.spacing(8)} + 1px)`,
  },
});

const DrawerHeader = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'flex-start',
  padding: theme.spacing(1, 2),
  background: '#ffffff',
  borderBottom: '1px solid #e5e7eb',
  position: 'relative',
  zIndex: 1,
  minHeight: '64px',
  gap: theme.spacing(2),
  ...theme.mixins.toolbar,
}));

const Drawer = styled(MuiDrawer, { shouldForwardProp: (prop) => prop !== 'open' })(
  ({ theme }) => ({
    width: drawerWidth,
    flexShrink: 0,
    whiteSpace: 'nowrap',
    boxSizing: 'border-box',
    variants: [
      {
        props: ({ open }) => open,
        style: {
          ...openedMixin(theme),
          '& .MuiDrawer-paper': openedMixin(theme),
        },
      },
      {
        props: ({ open }) => !open,
        style: {
          ...closedMixin(theme),
          '& .MuiDrawer-paper': closedMixin(theme),
        },
      },
    ],
  }),
);

function Alert(props) {
  return <MuiAlert elevation={6} variant="filled" {...props} />;
}

const Header = (props) => {
  const { userType, userIdType, userRecords, userRecruitmentpartnerId, switchRole, referralPartners } = useContext(UserTypeContext);
  const [recruiter, setRecruiter] = useState("");
  const [showResumeModal, setShowResumeModal] = useState(false);
  const [requisitionsMenuOpen, setRequisitionsMenuOpen] = useState(false);
  const location = useLocation();


  const goToHomePage = () => {
    history("/landing", { replace: true });
  };

  // Navigation functions with state passing like in AtsDashNav
  const navigateTo = (pageName) => {
    history(`/${pageName}`, {
      state: {
        id: userIdType,
        recruitmentPartnerId: userRecruitmentpartnerId,
        userType: userType,
        userRecords: userRecords,
        userRole: recruiter
      }
    });
  };

  const goToRequisitionReports = () => {
    history("/requisition-reports", {
      state: {
        id: userIdType,
        userType: userType,
        userRecords: userRecords,
        userRole: recruiter,
        userRecruitmentpartnerId: userRecruitmentpartnerId
      }
    });
    
  };

  const gotoPendingInvites = () => {
    history("/pending-invites", {
      state: {
        id: userIdType,
        userType: userType,
        userRecords: userRecords,
        userRole: recruiter,
        userRecruitmentpartnerId: userRecruitmentpartnerId
      }
    });
    
  };

  const handleUploadResumes = () => {
    setShowResumeModal(true);
  };

  // Role switching functionality from AtsDashNav
  const roleSwitcher = (role) => {
    if (switchRole) {
      switchRole(role);
    }
    setSelectedRole(role);
    setRecruiter(role); // Update the recruiter state to reflect the new role
    setIsRoleSwitchOpen(false);
    setIsDrawerOpen(false);
  };

  // Administration menu toggle
  const administrationOpen = () => {
    setAdministrationMenuOpen(!administrationMenuOpen);
  };

  // Pending Actions menu toggle
  const pendingActionsOpen = () => {
    setPendingActionsMenuOpen(!pendingActionsMenuOpen);
  };

  const toggleRoleSwitch = () => {
    setIsRoleSwitchOpen(!isRoleSwitchOpen);
  };

  // Fetch roles like in AtsDashNav
  useEffect(() => {
    const roleFetcher = async () => {
      try {
        const roles = await allRoles();
        if (roles.status === 200) {
          const Role = roles?.data?.data?.filter((elem) => elem?.id === userRecords?.roleId)[0];
          const codes = Role?.accessRoles;
          setRoleCodes(codes || []);
        }
      } catch (error) {
        console.log(error);
        setRoleCodes([]);
      }
    };

    roleFetcher();
  }, []);



  // Add this function for requisitions menu toggle
  const requisitionsOpen = () => {
    setRequisitionsMenuOpen(!requisitionsMenuOpen);
  };


  const requisitionsMenuItems = [
    {
      text: 'Requisition Dashboard',
      icon: <DescriptionIcon />,
      onClick: () => navigateTo('requisition-dashboard'),
      visible: true
    },
    {
      text: 'Add Requisition',
      icon: <AddPlusIcon />,
      onClick: () => navigateTo('create-requisition'),
      visible: userType === 'MIS Operator'
    },
    {
      text: 'Search Requisitions',
      icon: <StarIcon />,
      onClick: () => navigateTo('search-requisitions'),
      visible: true
    },
    {
      text: "Candidate History",
      icon: <PersonPinCircleOutlined />,
      onClick: () => navigateTo('candidate-history'),
      visible: userType === 'Recruitment Leader' || userType === 'Recruiter'
    }
  ];

  const menuItems = [
    {
      text: 'Dashboard',
      icon: <DashboardIcon />,
      onClick: () => navigateTo('dashboard'),
      visible: location.pathname !== '/dashboard'
    },
    {
      text: 'Screening Dashboard',
      icon: <DashboardCustomizeIcon />,
      onClick: () => navigateTo('interview-management'),
      visible: true
    },
     {
      text: 'Verbal English Test',
      icon: <VetIcon />,
      onClick: () => navigateTo('interview-management-vet'),
      visible: true
    },
    {
      text: 'Candidate Search',
      icon: <SearchIcon />,
      onClick: () => navigateTo('candidate-search-talent-community'),
      visible: true
    },
    {
      text: 'Reports',
      icon: <ReportsIcon />,
      onClick: () => goToRequisitionReports(),
      visible: userType === "Organization Admin" || userType === 'Recruitment Leader' || userType === "Team Leader" || userType === "MIS Operator" || (userType === 'Admin' && (recruiter === 'Organization Admin' || recruiter === 'Recruitment Leader'))
    },
    {
      text: 'Upload Resume',
      icon: <CloudUploadIcon />,
      onClick: () => handleUploadResumes(),
      visible: userType !== 'Admin' && userType !== 'Organization Admin'
    },
    {
      text: 'Invite Candidate To Take Test',
      icon: <FolderSharedIcon />,
      onClick: () => navigateTo('invite-candidates'),
      visible: userType !== 'Admin'
    },
    {
      text: 'Support',
      icon: <SupportAgentIcon />,
      onClick: () => openSupportModal(),
      visible: true
    },
    {
      text: 'Sign Out',
      icon: <LogoutIcon />,
      onClick: () => signOut(),
      visible: true
    }
  ];

  // Pending Actions menu items
  const pendingActionsItems = [
    {
      text: 'Pending Invites',
      icon: <PendingInvitesIcon />,
      onClick: () => gotoPendingInvites(),
      visible: true
    },
    {
      text: 'Pending Referral',
      icon: <PendingReferralIcon />,
      onClick: () => navigateTo('mytalent-referral'),
      visible: (userType !== 'Admin') && (referralPartners === true) && (userRecords?.agency?.agencyType?.code === "internal")
    },
    {
      text: 'Pending Resume Validation',
      icon: <PendingResumeValidationIcon />,
      onClick: () => navigateTo('pending-resume-validations'),
      visible: true
    }
  ];

  const history = useNavigate();
  const [profilePicture, setProfilePicture] = useState(profile);
  const [userfirstname, setUserFirstName] = useState("");
  const [userlastname, setUserLastName] = useState("");
  const [logo, setLogo] = useState("");
  const [open, setOpen] = useState(false);
  const [loader, setLoader] = useState(false);
  const [isNotificationOpen, setIsNotificationOpen] = useState(false)
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);
  const [allNotifications, setAllNotifications] = useState([]);
  const [newNotificationCount, setNewNotificationCount] = useState(0);
  const [modalForShare, setmodalForShare] = useState(false);
  const [hamburgerIsClicked, setHamburgerIsClicked] = useState(false)

  const [mailValidate, setMailValidate] = useState(false);

  const isMobile = useMediaQuery('(max-width:768px)');

  // State for role switching and administration menu
  const [isRoleSwitchOpen, setIsRoleSwitchOpen] = useState(false);
  const [administrationMenuOpen, setAdministrationMenuOpen] = useState(false);
  const [pendingActionsMenuOpen, setPendingActionsMenuOpen] = useState(false);
  const [roleCodes, setRoleCodes] = useState([]);
  const [selectedRole, setSelectedRole] = useState(userType); // Initialize with userType initially


  const [candidateMenuOpen, setCandidateMenuOpen] = useState(false);
  const [loaderBackdrop, setLoaderBackdrop] = useState(false);

  const candidateMenuToggle = () => {
    setCandidateMenuOpen(!candidateMenuOpen);
  };


  const candidateMenuItems = [
    {
      text: 'Share',
      icon: <ShareIcon />,
      onClick: () => openShare(),
      visible: true
    },
    {
      text: 'Support',
      icon: <SupportAgentIcon />,
      onClick: () => openSupportModal(),
      visible: true
    },
    {
      text: 'Sign Out',
      icon: <LogoutIcon />,
      onClick: () => signOut(),
      visible: true
    }
  ];

  // Administration menu items
  const administrationMenuItems = [
    {
      text: 'Manage Team',
      icon: <ManageTeamIcon />,
      onClick: () => navigateTo('orgManageTeam')
    },
    {
      text: 'Manage Division',
      icon: <ManageDivisionIcon />,
      onClick: () => navigateTo('orgManageDivision')
    },
    {
      text: 'Manage Client',
      icon: <ManageClientIcon />,
      onClick: () => navigateTo('orgManageClient')
    },
    {
      text: 'Manage POC',
      icon: <ManagePOCIcon />,
      onClick: () => navigateTo('orgManageSpoc')
    },
    {
      text: 'Manage User',
      icon: <ManageUserIcon />,
      onClick: () => navigateTo('users'),
      visible: userType === "Organization Admin" || userType === "MIS Operator" || (userType === 'Admin' && recruiter === 'Organization Admin') || (userType === 'Admin' && recruiter === 'MIS Operator')
    },
    {
      text: 'Sign Up Requests',
      icon: <ContactMailIcon />,
      onClick: () => navigateTo('sign-up-page'),
      visible: (userType === "Organization Admin" || userType === "MIS Operator" || (userType === 'Admin' && recruiter === 'Organization Admin') || (userType === 'Admin' && recruiter === 'MIS Operator')) && userType !== 'Admin'
    }
  ];

  const roles = roleCodes?.length > 1 ? roleCodes.filter((role) => role !== userType) : [
    'Recruitment Leader',
    'Team Leader',
    'Recruiter'
  ];
  const openShare = async () => {
    setmodalForShare(true);
  };
  const openSupportModal = () => {
    setOpen(true);
  }

  // const toggleDrawer = (open) => (event) => {
  //   if (event.type === 'keydown' && (event.key === 'Tab' || event.key === 'Shift')) {
  //     return;
  //   }
  //   setIsDrawerOpen(open);
  // };

  const _modalClose = () => {
    setOpen(false);
  }



  const notificationModuleClose = () => {
    setIsNotificationOpen(false)
  }

  const gotoAllNotification = () => {
    history("/all-notification");
  }

  const handleCloseSnackBar = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setMailValidate(false);
  };

  const hamburgerClicked = () => {
    setHamburgerIsClicked(!hamburgerIsClicked);
    const newDrawerState = !isDrawerOpen;
    setIsDrawerOpen(newDrawerState);

    // Notify parent Layout component of drawer state change
    if (props.onDrawerStateChange) {
      props.onDrawerStateChange(newDrawerState);
    }
  }


  useEffect(() => {
    let mounted = true;
    const getUserData = async () => {
      if (mounted) {
        setUserFirstName(userRecords?.firstName);
        setUserLastName(userRecords?.lastName);
        setLogo(userRecords?.recruitmentpartner?.recruitmentpartnerLogoUrl);
        setProfilePicture(userRecords?.profile?.profilePicUrl);
        setLoader(true);
        const roleName = userRecords?.role?.roleName;
        setRecruiter(roleName);
        setSelectedRole(roleName || userType); // Update selectedRole when recruiter is set
      }
    }
    getUserData();
    return () => mounted = false;
  }, [userRecords])


  const signOut = async () => {
    try {
      setLoaderBackdrop(true); // start backdrop loader

      await customLogoutResponse({
        userId: localStorage.getItem('userID'),
        recruitementPartnerId: userRecruitmentpartnerId,
      });

      await userSessionLogs(
        localStorage.getItem('userID'),
        localStorage.getItem('token')
      );

      localStorage.removeItem('userID');
      localStorage.removeItem('role');
      localStorage.removeItem('token');

      history('/', { replace: true }); // page navigation will automatically remove the backdrop
    } catch (error) {
      console.error(error);
      setLoaderBackdrop(false); // in case of error, hide loader so user can retry
    }
  };


  const goToAccountSetting = () => {
    history("/account-settings", { replace: true });
  }


  const allNotification = async () => {
    if (userType === "Recruiter" || userType === "Recruitment Leader" || userType === "Team Leader") {
      let payload = {
        id: userIdType,
        role: userType,
        skip: 0,
        size: 5,
        isViewed: false
      }
      try {
        const response_unRead = await getAllNotification(payload)
        setNewNotificationCount(response_unRead?.data?.data?.totalCount)

        payload.isViewed = "all"
        const response_All = await getAllNotification(payload)
        setAllNotifications(response_All?.data?.data?.notifications)

      } catch (error) {
        console.log(error, "error");
      }
    }

  }

  const readedNotificationId = async (item) => {
    let payload = {
      _id: item._id,
      userId: item.receiverData.id,
      updateAll: false
    }
    try {
      await updateNotification(payload)
      if (userType === "Recruitment Leader") {
        if (item?.requisitionDetails?.assignedTo === userIdType) {
          history(`/requisition-details/${item.requisitionId}`)
          setIsNotificationOpen(!isNotificationOpen)
        }
        else {
          if (item?.receiverData?.isViewed === false) {
            const index = allNotifications.findIndex(dataitem => dataitem._id === item._id);
            const updatedAllNotifications = allNotifications.map((dataitem, idx) =>
              idx === index
                ? { ...dataitem, receiverData: { ...dataitem.receiverData, isViewed: true } }
                : dataitem
            );
            setAllNotifications(updatedAllNotifications);
            setNewNotificationCount(newNotificationCount - 1)
          }
        }
      }
      else if (userType === 'Recruiter') {
        let data = item?.recruiterRequisition?.filter((dataitem) => dataitem.recruiterId === userIdType && dataitem?.isActive === true)
        if (data.length > 0) {
          history(`/requisition-details/${item.requisitionId}`)
          setIsNotificationOpen(!isNotificationOpen)
        }
        else {
          if (item?.receiverData?.isViewed === false) {
            const index = allNotifications.findIndex(dataitem => dataitem._id === item._id);
            const updatedAllNotifications = allNotifications.map((dataitem, idx) =>
              idx === index
                ? { ...dataitem, receiverData: { ...dataitem.receiverData, isViewed: true } }
                : dataitem
            );
            setAllNotifications(updatedAllNotifications);
            setNewNotificationCount(newNotificationCount - 1)
          }
        }
      }
      else if (userType === "Team Leader") {
        let data = item?.teamleaderrequisitions?.filter((dataitem) => dataitem.team.teamLeaderId === userIdType && dataitem?.isActive === true)
        if (data.length > 0) {
          history(`/requisition-details/${item.requisitionId}`)
          setIsNotificationOpen(!isNotificationOpen)
        } else {
          if (item?.receiverData?.isViewed === false) {
            const index = allNotifications.findIndex(dataitem => dataitem._id === item._id);
            const updatedAllNotifications = allNotifications.map((dataitem, idx) =>
              idx === index
                ? {
                  ...dataitem, receiverData: { ...dataitem.receiverData, isViewed: true }
                }
                : dataitem
            )
            setAllNotifications(updatedAllNotifications);
            setNewNotificationCount(newNotificationCount - 1)
          }
        }
      }
    } catch (error) {
      console.log(error, "error");
    }
  }

  useEffect(() => {
    allNotification()
  }, [userType])

  // Notify Layout component of initial drawer state
  useEffect(() => {
    if (props.onDrawerStateChange) {
      props.onDrawerStateChange(isDrawerOpen);
    }
  }, [isDrawerOpen, props.onDrawerStateChange]);

  return (
    userType === "Admin" ? (
      <>
        <header className="header-dashboard-main">
          <div className="header-container-main">
            <div className="header-logo-area" onClick={goToHomePage}>
              <img src={recruiter_header_logo} alt="logo" className="header-logo-image" />
            </div>
            <button className="header-signout-button-modern" onClick={signOut} aria-label="Sign Out">
              <LogoutIcon fontSize="medium" />
              <span>Sign Out</span>
            </button>
          </div>
        </header>
      </>
    ) : (
      <Box className="header-drawer-flex-container">
        <CssBaseline />

        {/* Header */}
        <header className="header-dashboard-main header-fixed-position">
          <div className="header-container-main">
            <div className="header-logo-area">
              {isMobile && userType !== "Candidate" && (
                <IconButton
                  aria-label="open drawer"
                  onClick={hamburgerClicked}
                  className="header-hamburger-menu-btn"
                  size="small"
                >
                  <MenuIcon />
                </IconButton>
              )}
              <img src={recruiter_header_logo} alt="logo" className="header-logo-image" onClick={goToHomePage} />
            </div>

            <div className="header-right-section">
              {/* Notification Bell */}
              {loader && userType !== "MIS Operator" && userType !== "Candidate" && userType !== "Organization Admin" && !props?.isNotificationPage && props?.poweResumeAvialable === undefined && userType && (
                <div className="header-notification-wrapper">
                  <Badge
                    badgeContent={newNotificationCount}
                    color="error"
                    className="header-notification-badge"
                  >
                    <div className="header-notification-icon" onClick={() => setIsNotificationOpen(!isNotificationOpen)}>
                      <NotificationsIcon className="header-bell-icon-img" alt="bell" />
                    </div>
                  </Badge>

                  {isNotificationOpen && (
                    <ClickAwayListener onClickAway={notificationModuleClose}>
                      <div className={`header-notification-dropdown ${userType === "Recruiter" ? "recruiterView" : ""}`}>
                        <div className="header-dropdown-title">Notifications</div>
                        <div className="header-dropdown-body">
                          {allNotifications.length > 0 ? allNotifications.map((item, i) => (
                            <div
                              key={i}
                              className={item?.receiverData?.isViewed ? "header-notification-item" : "header-notification-item unread"}
                              onClick={() => readedNotificationId(item)}
                            >
                              <InfoOutlinedIcon className="iconColor" />
                              <div className="notificationText">{item?.receiverData?.message}</div>
                            </div>
                          )) : <div className="header-no-notification">No recent notifications!</div>}
                        </div>
                        <div className="header-view-all-btn" onClick={gotoAllNotification}>View All</div>
                      </div>
                    </ClickAwayListener>
                  )}
                </div>
              )}

              {/* Profile Dropdown */}

              {/* Organization Logo or Candidate Name Dropdown */}
              {userType === "Candidate" ? (
                <div className="header-organization-logo-section">
                  <div className="header-candidate-dropdown-container">
                    <ClickAwayListener onClickAway={() => setCandidateMenuOpen(false)}>
                      <div className="header-candidate-name-wrapper">
                        <button
                          className="header-candidate-name-button"
                          onClick={candidateMenuToggle}
                          aria-label="Candidate Menu"
                        >
                          <span className="header-candidate-name-text">
                            {userfirstname} {userlastname}
                          </span>
                          <DropdownArrowIcon
                            width={20}
                            height={20}
                            className={`header-candidate-dropdown-arrow ${candidateMenuOpen ? 'rotated' : ''}`}
                          />
                        </button>

                        {candidateMenuOpen && (
                          <div className="header-candidate-dropdown-menu">
                            {candidateMenuItems.filter(item => item.visible !== false).map((item) => (
                              <button
                                key={item.text}
                                className="header-candidate-menu-item"
                                onClick={() => {
                                  item.onClick();
                                  setCandidateMenuOpen(false);
                                }}
                              >
                                <div className="header-candidate-menu-icon">
                                  {item.icon}
                                </div>
                                <span className="header-candidate-menu-text">
                                  {item.text}
                                </span>
                              </button>
                            ))}
                          </div>
                        )}
                      </div>
                    </ClickAwayListener>
                  </div>
                </div>
              ) : (
                logo && (
                  <div className="header-organization-logo-section">
                    <img
                      src={logo}
                      alt="Organization Logo"
                      className="header-organization-logo"
                    />
                  </div>
                )
              )}
            </div>
          </div>
        </header>

        <Backdrop
          sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
          open={loaderBackdrop}
        >
          <div className="header_backdrop_content">
            <CircularProgress color="inherit" />
            <div className="header_backdrop_text" >Signing out...</div>
          </div>
        </Backdrop>

        {/* Drawer - permanent on desktop, temporary on mobile; hidden by default on mobile */}
        {props?.poweResumeAvialable === undefined && userType !== "Candidate" && (
          <div className="header-drawer-container">
            {isMobile ? (
              <MuiDrawer
                variant="temporary"
                open={isDrawerOpen}
                onClose={hamburgerClicked}
                ModalProps={{ keepMounted: true }}
                PaperProps={{ className: 'header-mobile-drawer-paper' }}
              >
                <Box className="header-drawer-main-container">
                  <DrawerHeader className="header-drawer-header">
                    <Tooltip title={isDrawerOpen ? 'Close sidebar' : 'Open sidebar'} placement="right">
                      <IconButton
                        aria-label="toggle drawer"
                        aria-expanded={isDrawerOpen}
                        onClick={hamburgerClicked}
                        className={`header-drawer-toggle-btn header-drawer-toggle-icon ${isDrawerOpen ? 'is-open' : ''}`}
                        size="small"
                      >
                        <ChevronLeftIcon />
                      </IconButton>
                    </Tooltip>
                  </DrawerHeader>

                  {/* Scrollable Content Area */}
                  <Box className="header-drawer-scrollable-content">
                    {/* Profile Section */}
                    {
                      !isDrawerOpen && <Tooltip
                        title="Account Settings"
                        placement="right"
                        disableHoverListener={isDrawerOpen}
                        arrow
                      >
                        <Box
                          className={`header-drawer-profile-section header-drawer-profile-closed-container ${isDrawerOpen ? 'drawer-open' : 'drawer-closed'}`}
                          onClick={goToAccountSetting}
                        >
                          <img
                            src={profilePicture || profile}
                            alt="profile"
                            className={isDrawerOpen ? "header-drawer-profile-img-open" : "header-drawer-profile-img-closed"}
                          />
                          {isDrawerOpen && (
                            <div className="header-drawer-profile-info">
                              <Typography
                                variant="subtitle1"
                                className="header-drawer-user-name"
                              >
                                {userfirstname} {userlastname}
                              </Typography>
                              <Typography
                                variant="caption"
                                className="header-drawer-user-role"
                              >
                                {recruiter}
                              </Typography>
                            </div>
                          )}
                        </Box>
                      </Tooltip>
                    }

                    {/* Role Switch - reuse same JSX as desktop */}
                    {roleCodes?.length > 1 && (
                      <List className="header-role-switch-section">
                        <ListItem disablePadding sx={{ display: 'block' }}>
                          <Tooltip
                            title="Switch Role"
                            placement="right"
                            disableHoverListener={isDrawerOpen}
                            arrow
                          >
                            <ListItemButton
                              onClick={() => {
                                if (!isDrawerOpen) {
                                  setIsDrawerOpen(true);
                                  setIsRoleSwitchOpen(true);
                                } else {
                                  toggleRoleSwitch();
                                }
                              }}
                              className={`header-role-switch-button ${isDrawerOpen ? 'drawer-open' : 'drawer-closed'}`}
                            >
                              <ListItemIcon className={`header-role-switch-icon ${isDrawerOpen ? 'drawer-open' : 'drawer-closed'}`}>
                                <SwitchRoleIcon />
                              </ListItemIcon>
                              {isDrawerOpen && (
                                <>
                                  <ListItemText
                                    primary="Switch Role"
                                    className="header-role-switch-text"
                                  />
                                  {isRoleSwitchOpen ? <ExpandLess /> : <ExpandMore />}
                                </>
                              )}
                            </ListItemButton>
                          </Tooltip>
                        </ListItem>

                        {isDrawerOpen && (
                          <Collapse in={isRoleSwitchOpen} timeout="auto" unmountOnExit>
                            <List component="div" disablePadding className="header-role-list">
                              {roles.map((role) => (
                                <ListItem key={role} disablePadding sx={{ display: 'block' }}>
                                  <ListItemButton
                                    onClick={() => roleSwitcher(role)}
                                    className={`header-role-item ${selectedRole === role ? 'selected' : ''}`}
                                  >
                                    <ListItemIcon className="header-role-item-icon">
                                      <PersonPinCircleOutlined fontSize="small" />
                                    </ListItemIcon>
                                    <ListItemText
                                      primary={role}
                                      className={`header-role-item-text ${selectedRole === role ? 'selected' : ''}`}
                                    />
                                  </ListItemButton>
                                </ListItem>
                              ))}
                            </List>
                          </Collapse>
                        )}
                      </List>
                    )}

                    {(userType === "Organization Admin" || userType === "MIS Operator" || (userType === 'Admin' && (recruiter === 'Organization Admin' || recruiter === 'MIS Operator'))) && (
                      <>
                        <List className="header-admin-menu-section">
                          <ListItem disablePadding sx={{ display: 'block' }}>
                            <Tooltip
                              title="Administration"
                              placement="right"
                              disableHoverListener={isDrawerOpen}
                              arrow
                            >
                              <ListItemButton
                                onClick={() => {
                                  if (!isDrawerOpen) {
                                    setIsDrawerOpen(true);
                                    setAdministrationMenuOpen(true);
                                  } else {
                                    administrationOpen();
                                  }
                                }}
                                className={`header-administration-button ${isDrawerOpen ? 'drawer-open' : 'drawer-closed'}`}
                              >
                                <ListItemIcon className={`header-administration-icon ${isDrawerOpen ? 'drawer-open' : 'drawer-closed'}`}>
                                  <AdminPanelSettingsIcon />
                                </ListItemIcon>
                                {isDrawerOpen && (
                                  <>
                                    <ListItemText
                                      primary="Administration"
                                      className="header-administration-text"
                                    />
                                    {administrationMenuOpen ? <ExpandLess /> : <ExpandMore />}
                                  </>
                                )}
                              </ListItemButton>
                            </Tooltip>
                          </ListItem>

                          {isDrawerOpen && (
                            <Collapse in={administrationMenuOpen} timeout="auto" unmountOnExit>
                              <List component="div" disablePadding className="header-administration-list">
                                {administrationMenuItems.filter(item => item.visible !== false).map((item) => (
                                  <ListItem key={item.text} disablePadding sx={{ display: 'block' }}>
                                    <ListItemButton
                                      onClick={item.onClick}
                                      className="header-administration-item"
                                    >
                                      <ListItemIcon className="header-administration-item-icon">
                                        {item.icon}
                                      </ListItemIcon>
                                      <ListItemText
                                        primary={item.text}
                                        className="header-administration-item-text"
                                      />
                                    </ListItemButton>
                                  </ListItem>
                                ))}
                              </List>
                            </Collapse>
                          )}
                        </List>
                      </>
                    )}

                    <List className="header-pending-actions-section">
                      <ListItem disablePadding sx={{ display: 'block' }}>
                        <Tooltip
                          title="Pending Actions"
                          placement="right"
                          disableHoverListener={isDrawerOpen}
                          arrow
                        >
                          <ListItemButton
                            onClick={() => {
                              if (!isDrawerOpen) {
                                setIsDrawerOpen(true);
                                setPendingActionsMenuOpen(true);
                              } else {
                                pendingActionsOpen();
                              }
                            }}
                            className={`header-pending-actions-button ${isDrawerOpen ? 'drawer-open' : 'drawer-closed'}`}
                          >
                            <ListItemIcon className={`header-pending-actions-icon ${isDrawerOpen ? 'drawer-open' : 'drawer-closed'}`}>
                              <PendingActionsIcon />
                            </ListItemIcon>
                            {isDrawerOpen && (
                              <>
                                <ListItemText
                                  primary="Pending Actions"
                                  className="header-pending-actions-text"
                                />
                                {pendingActionsMenuOpen ? <ExpandLess /> : <ExpandMore />}
                              </>
                            )}
                          </ListItemButton>
                        </Tooltip>
                      </ListItem>

                      {isDrawerOpen && (
                        <Collapse in={pendingActionsMenuOpen} timeout="auto" unmountOnExit>
                          <List component="div" disablePadding className="header-pending-actions-list">
                            {pendingActionsItems.filter(item => item.visible !== false).map((item) => (
                              <ListItem key={item.text} disablePadding sx={{ display: 'block' }}>
                                <ListItemButton
                                  onClick={item.onClick}
                                  className="header-pending-actions-item"
                                >
                                  <ListItemIcon className="header-pending-actions-item-icon">
                                    {item.icon}
                                  </ListItemIcon>
                                  <ListItemText
                                    primary={item.text}
                                    className="header-pending-actions-item-text"
                                  />
                                </ListItemButton>
                              </ListItem>
                            ))}
                          </List>
                        </Collapse>
                      )}
                    </List>

                    <List className="header-requisitions-section">
                      <ListItem disablePadding sx={{ display: 'block' }}>
                        <Tooltip
                          title="Requisitions"
                          placement="right"
                          disableHoverListener={isDrawerOpen}
                          arrow
                        >
                          <ListItemButton
                            onClick={() => {
                              if (!isDrawerOpen) {
                                setIsDrawerOpen(true);
                                setRequisitionsMenuOpen(true);
                              } else {
                                requisitionsOpen();
                              }
                            }}
                            className={`header-requisitions-button ${isDrawerOpen ? 'drawer-open' : 'drawer-closed'}`}
                          >
                            <ListItemIcon className={`header-requisitions-icon ${isDrawerOpen ? 'drawer-open' : 'drawer-closed'}`}>
                              <RequisitionsIcon />
                            </ListItemIcon>
                            {isDrawerOpen && (
                              <>
                                <ListItemText
                                  primary="Requisitions"
                                  className="header-requisitions-text"
                                />
                                {requisitionsMenuOpen ? <ExpandLess /> : <ExpandMore />}
                              </>
                            )}
                          </ListItemButton>
                        </Tooltip>
                      </ListItem>

                      {isDrawerOpen && (
                        <Collapse in={requisitionsMenuOpen} timeout="auto" unmountOnExit>
                          <List component="div" disablePadding className="header-requisitions-list">
                            {requisitionsMenuItems.filter(item => item.visible !== false).map((item) => (
                              <ListItem key={item.text} disablePadding sx={{ display: 'block' }}>
                                <ListItemButton
                                  onClick={item.onClick}
                                  className="header-requisitions-item"
                                >
                                  <ListItemIcon className="header-requisitions-item-icon">
                                    {item.icon}
                                  </ListItemIcon>
                                  <ListItemText
                                    primary={item.text}
                                    className="header-requisitions-item-text"
                                  />
                                </ListItemButton>
                              </ListItem>
                            ))}
                          </List>
                        </Collapse>
                      )}
                    </List>

                    <List className="header-main-menu-section">
                      {menuItems.filter(item => item.visible !== false).map((item, index) => (
                        <ListItem key={item.text} disablePadding sx={{ display: 'block' }}>
                          <Tooltip
                            title={item.text}
                            placement="right"
                            disableHoverListener={isDrawerOpen}
                            arrow
                          >
                            <ListItemButton
                              onClick={item.onClick}
                              className={`header-menu-item ${isDrawerOpen ? 'drawer-open' : 'drawer-closed'}`}
                            >
                              <ListItemIcon className={`header-menu-item-icon ${isDrawerOpen ? 'drawer-open' : 'drawer-closed'}`}>
                                {item.icon}
                              </ListItemIcon>
                              <ListItemText
                                primary={item.text}
                                className={`header-menu-item-text ${isDrawerOpen ? 'drawer-open' : 'drawer-closed'}`}
                              />
                            </ListItemButton>
                          </Tooltip>
                        </ListItem>
                      ))}
                    </List>
                  </Box>
                </Box>
              </MuiDrawer>
            ) : (
              <Drawer variant="permanent" open={isDrawerOpen}>
                <Box className="header-drawer-main-container">
                  <DrawerHeader className="header-drawer-header">
                    <Tooltip title={isDrawerOpen ? 'Collapse sidebar' : 'Expand sidebar'} placement="right">
                      <IconButton
                        aria-label="toggle drawer"
                        aria-expanded={isDrawerOpen}
                        onClick={hamburgerClicked}
                        className={`header-drawer-toggle-btn header-drawer-toggle-icon ${isDrawerOpen ? 'is-open' : ''}`}
                        size="small"
                      >
                        {isDrawerOpen ? <ChevronLeftIcon /> : <MenuIcon />}
                      </IconButton>
                    </Tooltip>

                    {/* Profile Section - Separate from toggle button when drawer is open */}
                    {isDrawerOpen && (
                      <Box
                        className={`header-drawer-profile-section header-drawer-profile-container-open drawer-open`}
                      >
                        <img
                          src={profilePicture || profile}
                          alt="profile"
                          className="header-drawer-profile-img-open header-drawer-profile-img-style"
                        />
                        <div className="header-drawer-profile-info header-drawer-profile-info-container">
                          <div>
                            <Typography
                              variant="subtitle1"
                              className="header-drawer-user-name header-drawer-user-name-typography"
                            >
                              {userfirstname} {userlastname}
                            </Typography>
                            <Typography
                              variant="caption"
                              className="header-drawer-user-role header-drawer-user-role-typography"
                            >
                              {recruiter}
                            </Typography>
                          </div>
                          <Tooltip title="Account Settings" placement="top" arrow>
                            <IconButton
                              onClick={goToAccountSetting}
                              size="small"
                              className="header-profile-settings-icon"
                            >
                              <SettingsIcon fontSize="small" />
                            </IconButton>
                          </Tooltip>
                        </div>
                      </Box>
                    )}
                  </DrawerHeader>

                  {/* Scrollable Content Area */}
                  <Box className="header-drawer-scrollable-content">
                    {/* Profile Section */}
                    {
                      !isDrawerOpen && <Tooltip
                        title="Account Settings"
                        placement="right"
                        disableHoverListener={isDrawerOpen}
                        arrow
                      >
                        <Box
                          className={`header-drawer-profile-section header-drawer-profile-closed-container ${isDrawerOpen ? 'drawer-open' : 'drawer-closed'}`}
                          onClick={goToAccountSetting}
                        >
                          <img
                            src={profilePicture || profile}
                            alt="profile"
                            className={isDrawerOpen ? "header-drawer-profile-img-open" : "header-drawer-profile-img-closed"}
                          />
                          {isDrawerOpen && (
                            <div className="header-drawer-profile-info">
                              <Typography
                                variant="subtitle1"
                                className="header-drawer-user-name"
                              >
                                {userfirstname} {userlastname}
                              </Typography>
                              <Typography
                                variant="caption"
                                className="header-drawer-user-role"
                              >
                                {recruiter}
                              </Typography>
                            </div>
                          )}
                        </Box>
                      </Tooltip>
                    }


                    {/* <Divider className="header-drawer-divider" /> */}

                    {/* Role Switch - Show icon in mini sidebar, expand when clicked */}
                    {roleCodes?.length > 1 && (
                      <List className="header-role-switch-section">
                        <ListItem disablePadding sx={{ display: 'block' }}>
                          <Tooltip
                            title="Switch Role"
                            placement="right"
                            disableHoverListener={isDrawerOpen}
                            arrow
                          >
                            <ListItemButton
                              onClick={() => {
                                if (!isDrawerOpen) {
                                  setIsDrawerOpen(true);
                                  setIsRoleSwitchOpen(true);
                                } else {
                                  toggleRoleSwitch();
                                }
                              }}
                              className={`header-role-switch-button ${isDrawerOpen ? 'drawer-open' : 'drawer-closed'}`}
                            >
                              <ListItemIcon className={`header-role-switch-icon ${isDrawerOpen ? 'drawer-open' : 'drawer-closed'}`}>
                                <SwitchRoleIcon />
                              </ListItemIcon>
                              {isDrawerOpen && (
                                <>
                                  <ListItemText
                                    primary="Switch Role"
                                    className="header-role-switch-text"
                                  />
                                  {isRoleSwitchOpen ? <ExpandLess /> : <ExpandMore />}
                                </>
                              )}
                            </ListItemButton>
                          </Tooltip>
                        </ListItem>

                        {isDrawerOpen && (
                          <Collapse in={isRoleSwitchOpen} timeout="auto" unmountOnExit>
                            <List component="div" disablePadding className="header-role-list">
                              {roles.map((role) => (
                                <ListItem key={role} disablePadding sx={{ display: 'block' }}>
                                  <ListItemButton
                                    onClick={() => roleSwitcher(role)}
                                    className={`header-role-item ${selectedRole === role ? 'selected' : ''}`}
                                  >
                                    <ListItemIcon className="header-role-item-icon">
                                      <PersonPinCircleOutlined fontSize="small" />
                                    </ListItemIcon>
                                    <ListItemText
                                      primary={role}
                                      className={`header-role-item-text ${selectedRole === role ? 'selected' : ''}`}
                                    />
                                  </ListItemButton>
                                </ListItem>
                              ))}
                            </List>
                          </Collapse>
                        )}
                      </List>
                    )}

                    {/* Administration Menu - Show icon in mini sidebar, expand when clicked */}
                    {(userType === "Organization Admin" || userType === "MIS Operator" || (userType === 'Admin' && (recruiter === 'Organization Admin' || recruiter === 'MIS Operator'))) && (
                      <>
                        {/* <Divider className="header-drawer-divider" /> */}
                        <List className="header-admin-menu-section">
                          <ListItem disablePadding sx={{ display: 'block' }}>
                            <Tooltip
                              title="Administration"
                              placement="right"
                              disableHoverListener={isDrawerOpen}
                              arrow
                            >
                              <ListItemButton
                                onClick={() => {
                                  if (!isDrawerOpen) {
                                    setIsDrawerOpen(true);
                                    setAdministrationMenuOpen(true);
                                  } else {
                                    administrationOpen();
                                  }
                                }}
                                className={`header-administration-button ${isDrawerOpen ? 'drawer-open' : 'drawer-closed'}`}
                              >
                                <ListItemIcon className={`header-administration-icon ${isDrawerOpen ? 'drawer-open' : 'drawer-closed'}`}>
                                  <AdminPanelSettingsIcon />
                                </ListItemIcon>
                                {isDrawerOpen && (
                                  <>
                                    <ListItemText
                                      primary="Administration"
                                      className="header-administration-text"
                                    />
                                    {administrationMenuOpen ? <ExpandLess /> : <ExpandMore />}
                                  </>
                                )}
                              </ListItemButton>
                            </Tooltip>
                          </ListItem>

                          {isDrawerOpen && (
                            <Collapse in={administrationMenuOpen} timeout="auto" unmountOnExit>
                              <List component="div" disablePadding className="header-administration-list">
                                {administrationMenuItems.filter(item => item.visible !== false).map((item) => (
                                  <ListItem key={item.text} disablePadding sx={{ display: 'block' }}>
                                    <ListItemButton
                                      onClick={item.onClick}
                                      className="header-administration-item"
                                    >
                                      <ListItemIcon className="header-administration-item-icon">
                                        {item.icon}
                                      </ListItemIcon>
                                      <ListItemText
                                        primary={item.text}
                                        className="header-administration-item-text"
                                      />
                                    </ListItemButton>
                                  </ListItem>
                                ))}
                              </List>
                            </Collapse>
                          )}
                        </List>
                      </>
                    )}
                    {/* <Divider className="header-drawer-divider" /> */}

                    {/* Pending Actions Menu - Show icon in mini sidebar, expand when clicked */}
                    <List className="header-pending-actions-section">
                      <ListItem disablePadding sx={{ display: 'block' }}>
                        <Tooltip
                          title="Pending Actions"
                          placement="right"
                          disableHoverListener={isDrawerOpen}
                          arrow
                        >
                          <ListItemButton
                            onClick={() => {
                              if (!isDrawerOpen) {
                                setIsDrawerOpen(true);
                                setPendingActionsMenuOpen(true);
                              } else {
                                pendingActionsOpen();
                              }
                            }}
                            className={`header-pending-actions-button ${isDrawerOpen ? 'drawer-open' : 'drawer-closed'}`}
                          >
                            <ListItemIcon className={`header-pending-actions-icon ${isDrawerOpen ? 'drawer-open' : 'drawer-closed'}`}>
                              <PendingActionsIcon />
                            </ListItemIcon>
                            {isDrawerOpen && (
                              <>
                                <ListItemText
                                  primary="Pending Actions"
                                  className="header-pending-actions-text"
                                />
                                {pendingActionsMenuOpen ? <ExpandLess /> : <ExpandMore />}
                              </>
                            )}
                          </ListItemButton>
                        </Tooltip>
                      </ListItem>

                      {isDrawerOpen && (
                        <Collapse in={pendingActionsMenuOpen} timeout="auto" unmountOnExit>
                          <List component="div" disablePadding className="header-pending-actions-list">
                            {pendingActionsItems.filter(item => item.visible !== false).map((item) => (
                              <ListItem key={item.text} disablePadding sx={{ display: 'block' }}>
                                <ListItemButton
                                  onClick={item.onClick}
                                  className="header-pending-actions-item"
                                >
                                  <ListItemIcon className="header-pending-actions-item-icon">
                                    {item.icon}
                                  </ListItemIcon>
                                  <ListItemText
                                    primary={item.text}
                                    className="header-pending-actions-item-text"
                                  />
                                </ListItemButton>
                              </ListItem>
                            ))}
                          </List>
                        </Collapse>
                      )}
                    </List>

                    {/* Requisitions Menu - Show icon in mini sidebar, expand when clicked */}
                    <List className="header-requisitions-section">
                      <ListItem disablePadding sx={{ display: 'block' }}>
                        <Tooltip
                          title="Requisitions"
                          placement="right"
                          disableHoverListener={isDrawerOpen}
                          arrow
                        >
                          <ListItemButton
                            onClick={() => {
                              if (!isDrawerOpen) {
                                setIsDrawerOpen(true);
                                setRequisitionsMenuOpen(true);
                              } else {
                                requisitionsOpen();
                              }
                            }}
                            className={`header-requisitions-button ${isDrawerOpen ? 'drawer-open' : 'drawer-closed'}`}
                          >
                            <ListItemIcon className={`header-requisitions-icon ${isDrawerOpen ? 'drawer-open' : 'drawer-closed'}`}>
                              <RequisitionsIcon />
                            </ListItemIcon>
                            {isDrawerOpen && (
                              <>
                                <ListItemText
                                  primary="Requisitions"
                                  className="header-requisitions-text"
                                />
                                {requisitionsMenuOpen ? <ExpandLess /> : <ExpandMore />}
                              </>
                            )}
                          </ListItemButton>
                        </Tooltip>
                      </ListItem>

                      {isDrawerOpen && (
                        <Collapse in={requisitionsMenuOpen} timeout="auto" unmountOnExit>
                          <List component="div" disablePadding className="header-requisitions-list">
                            {requisitionsMenuItems.filter(item => item.visible !== false).map((item) => (
                              <ListItem key={item.text} disablePadding sx={{ display: 'block' }}>
                                <ListItemButton
                                  onClick={item.onClick}
                                  className="header-requisitions-item"
                                >
                                  <ListItemIcon className="header-requisitions-item-icon">
                                    {item.icon}
                                  </ListItemIcon>
                                  <ListItemText
                                    primary={item.text}
                                    className="header-requisitions-item-text"
                                  />
                                </ListItemButton>
                              </ListItem>
                            ))}
                          </List>
                        </Collapse>
                      )}
                    </List>

                    {/* Main Menu Items */}
                    <List className="header-main-menu-section">
                      {menuItems.filter(item => item.visible !== false).map((item, index) => (
                        <ListItem key={item.text} disablePadding sx={{ display: 'block' }}>
                          <Tooltip
                            title={item.text}
                            placement="right"
                            disableHoverListener={isDrawerOpen}
                            arrow
                          >
                            <ListItemButton
                              onClick={item.onClick}
                              className={`header-menu-item ${isDrawerOpen ? 'drawer-open' : 'drawer-closed'}`}
                            >
                              <ListItemIcon className={`header-menu-item-icon ${isDrawerOpen ? 'drawer-open' : 'drawer-closed'}`}>
                                {item.icon}
                              </ListItemIcon>
                              <ListItemText
                                primary={item.text}
                                className={`header-menu-item-text ${isDrawerOpen ? 'drawer-open' : 'drawer-closed'}`}
                              />
                            </ListItemButton>
                          </Tooltip>
                        </ListItem>
                      ))}
                    </List>
                  </Box>
                </Box>
              </Drawer>
            )}
          </div>
        )}

        {/* Layout component now handles body positioning */}

        {/* ...existing modals and dialogs remain the same... */}
        <HomeContactUsModal modalOpen={open} modalClose={_modalClose} />
        <SharePowerResume
          modalForShare={modalForShare}
          setmodalForShare={setmodalForShare}
          candidateEmailId={userRecords.email}
          candidateId={userRecords.id}
          userType={userType}
          userRecords={userRecords}
          userId={userIdType}
        />
        <Snackbar
          open={mailValidate}
          autoHideDuration={6000}
          onClose={handleCloseSnackBar}
        >
          <Alert
            onClose={handleCloseSnackBar}
            severity="error"
            className="remove-snackbar-alert"
          >
            Please enter your question.
          </Alert>
        </Snackbar>
        {
          showResumeModal && (
            <UploadResumeModal
              showResumeModal={showResumeModal}
              setShowResumeModal={setShowResumeModal}
              id={userIdType}
              userRecruitmentpartnerId={userRecruitmentpartnerId}
            />
          )
        }
      </Box>
    )

  );
};

export default Header;
